/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_SubtitleInputs */

const cs_listing_portals_subtitle = /** @type {(inputs: Listing_Portals_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojte portály kanceláře. U XML portálů zkopírujte feed URL. Portály bez veřejného CRM API zůstávají ve stavu Připravujeme.`)
};

const en_listing_portals_subtitle = /** @type {(inputs: Listing_Portals_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect office portals. XML portals get a feed URL to paste. Portals without a public CRM API stay Coming soon until a protocol is wired.`)
};

/**
* | output |
* | --- |
* | "Connect office portals. XML portals get a feed URL to paste. Portals without a public CRM API stay Coming soon until a protocol is wired." |
*
* @param {Listing_Portals_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_subtitle = /** @type {((inputs?: Listing_Portals_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_subtitle(inputs)
	return cs_listing_portals_subtitle(inputs)
});